import styled from '@emotion/styled';

export const GameEventFormTimeContainer = styled.div`
  display: flex;

  .period,
  .time {
    flex: 1;
  }
`;
